const Tooltip = ({ text }) => {
  return (
    <span className="absolute left-1/2 bottom-full mb-2 -translate-x-1/2 scale-0 transform whitespace-nowrap rounded-md bg-primary px-2 py-1 text-xs text-white opacity-0 transition-all group-hover:scale-100 group-hover:opacity-100">
      {text}
    </span>
  );
};

export default Tooltip;